import { Button, CircularProgress,Slide, Stack, TextField, Alert } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar, Snackbar } from "notistack";
import React, { useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";
import { useHistory, Link } from "react-router-dom";


const Register = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loadreg,setLoadreg] = useState(false);
  const [formData,setFormData] = useState({
   username:"",
   password:"",
   confirmPassword:""
  })
  const history = useHistory()
  
  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  const register = async (formData) => {

    const valid = validateInput(formData)
    if(!valid){return}
      try{
        setLoadreg(true)
        await axios.post(`${config.endpoint}/auth/register`,{
          username: formData.username,
          password: formData.password
        });

        setFormData({
          username:"",
          password:"",
          confirmPassword:"",
        });
        enqueueSnackbar("Registered Successfully",{ variant: "success"});
        setLoadreg(false)
        history.push("/login", { from: "Register" })
      } catch(e){
        
        if(e.response && e.response.status === 400 ){
          setLoadreg(false)
         return enqueueSnackbar(e.response.data.message, {variant:"error"});
        }else{
          setLoadreg(false)
           enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON.",{variant:"error"})
        }
        
      
      
    }   

  };
  
  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  const validateInput = (data) => {
    let check=true
    console.log(data)
    if(data.username.length===0){
      check=false
      enqueueSnackbar("Username is a required field", {
        variant: 'warning'
    });
    }
    else if(data.username.length<6){
      check=false
      enqueueSnackbar("Username must be at least 6 characters", {
        variant: 'warning'
    });
    }
    else if(data.password.length===0){
      check=false
      enqueueSnackbar("Password is a required field", {
        variant: 'warning'
    });
    }
    else if(data.password.length<6){
      check=false
      enqueueSnackbar("Password must be at least 6 characters", {
        variant: 'warning'
    });
    }
    else if(data.password!==data.confirmPassword){
      check=false
      enqueueSnackbar("Passwords do not match", {
        variant: 'warning'
    });
    }
    return check
  };

  const handleChange = (e) =>{
    let key = e.target.name;

    let value = e.target.value;

    setFormData((formData) => ({ ...formData, [key]: value }));

  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons />
      <Box className="content">

          <Stack spacing={2} className="form" onChange={handleChange}>
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            value={formData.username}
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            fullWidth
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            value={formData.password}
            name="password"
            type="password"
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            value={formData.confirmPassword}
            type="password"
            fullWidth
          />
          {loadreg ?   
            <Box sx={{ display: 'flex' , justifycontent: 'center' }}>
              <CircularProgress />
            </Box>
            :
               <Button className="button" onClick={async () => await register(formData)} variant="contained">
               Register Now
              </Button>
            }
          
          <p className="secondary-action">
            Already have an account?{" "}
            <Link className="link" to="/login">Login Here</Link>

          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
